<template>
  <main>
    <!-- <button @click="test">hola</button> -->
    <collapse :multiple-active="false" :activeIndex="-1">
      <collapse-item
        name="shifts"
        @collapseItemClosed="handleShiftDetailClose()"
      >
        <template slot="title">
          <span class="lead font-weight-bold">TURNOS</span>
        </template>
        <div class="d-flex flex-row justify-content-around">
          <!-- Tabla Turnos -->
          <shifts-table
            :shrinkProp.sync="shrinkShiftsTable"
            @shiftClicked="handleShowShift"
            :paginationProp="{ total: shiftsCount }"
            :tableData.sync="shifts"
            @pageChage="handlePageChange"
            ref="shiftsTable"
          ></shifts-table>
          <!-- Detalle Turnos -->
          <transition
            name="fade"
            enter-active-class="animate__animated animate__fadeInRight"
            leave-active-class="animate__animated animate__fadeOutRight"
            class="animate__delay-2s"
          >
            <shift-detail-card
              v-if="showShiftDetails"
              :shiftData.sync="shiftDetails"
              :enableEditProp.sync="enableShiftEdit"
              @deleteShift="handleDeleteShift"
              @closingShiftsDetails="handleShiftDetailClose"
              @restoreOriginalShiftData="handleDisablingEditing"
              @saveChanges="handleShiftChangesSaving"
              ref="shiftDetailCard"
            ></shift-detail-card>
          </transition>
        </div>
      </collapse-item>
      <collapse-item name="families">
        <template slot="title">
          <span class="lead font-weight-bold">FAMILIAS</span>
        </template>
      </collapse-item>
      <collapse-item name="subfamilies">
        <template slot="title">
          <span class="lead font-weight-bold">SUB-FAMILIAS</span>
        </template>
      </collapse-item>
    </collapse>
  </main>
</template>

<script>
import _ from "lodash";
import shiftsTable from "./Shifts/ShiftsTable.vue";
import shiftDetailCard from "./Shifts/ShiftDetail.vue";
import {
  Badge,
  Collapse,
  CollapseItem,
  Tabs,
  TabPane,
  Card,
} from "src/components/UIComponents";
export default {
  components: {
    Badge,
    shiftsTable,
    shiftDetailCard,
    CollapseItem,
    Collapse,
  },
  data() {
    return {
      shifts: [],
      shiftsCount: 0,
      shrinkShiftsTable: false,
      showShiftDetails: false, //
      shiftDetails: {},
      enableShiftEdit: null,
    };
  },
  watch: {
    shiftDetails: function (newValue) {
      Object.keys(newValue).forEach((key) => {
        switch (true) {
          case /Hora/.test(key):
            // console.log("formateanding " + key);
            // Realizar validación con expresión regular
            let valor = newValue[key];
            const formatoIncompleto = /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(valor);
            valor = formatoIncompleto ? valor + ":00" : valor;
            this.shiftDetails[key] = valor;
            // console.log(valor);
            // console.log(this.shiftDetails[key]);
            break;
          default:
            break;
        }
      });
    },
  },
  methods: {
    test(data) {
      // console.log("datasssssssssssssssssssssssssssss");
      console.log("this.shiftDetails");
      console.log(this.shiftDetails);
    },
    async handleShiftChangesSaving() {
      this.$swal.fire({
        text: "Un momento por favor...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      var { id, ...updatedShift } = this.shiftDetails;
      var errFields = [];
      var response;
      Object.keys(updatedShift).forEach((key) => {
        switch (true) {
          case /Hora/.test(key):
            // Realizar validación con expresión regular
            let valor = updatedShift[key];
            // console.log("*******************************************");
            // console.log(key);
            // console.log("valor");
            // console.log(valor);
            const formatoIncompleto = /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(valor);

            valor = formatoIncompleto ? valor + ":00" : valor;
            // console.log("formatoIncompleto");
            // console.log(formatoIncompleto);
            // console.log("valor");
            // console.log(valor);
            updatedShift[key] = formatoIncompleto ? valor : updatedShift[key];
            // console.log("*******************************************");
            const formatoCorrecto = /^(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d$/.test(
              valor
            );

            if (!formatoCorrecto || !valor) {
              errFields.push(key);
            }
            break;
          case /Autorizado/.test(key):
            // Verificar si el valor es un booleano
            const valorAutorizado = updatedShift[key];

            if (typeof valorAutorizado != "boolean") {
              errFields.push(key);
            }
            break;
          case /descripcionTurno/.test(key):
            // Verificar si el valor es un booleano
            const descripcionTurno = updatedShift[key];

            if (!descripcionTurno || typeof descripcionTurno != "string") {
              errFields.push(key);
            }
            break;
          default:
            break;
        }
      });
      if (errFields.length != 0) {
        this.$swal.close();
        // console.log("oooooooo");
        const warnText =
          errFields.length > 1
            ? `Al parecer hay un error en los campos ${errFields.join(", ")}.`
            : `Al parecer hay un error en el campo ${errFields[0]}`;
        this.$swal.fire({
          title: "Revisa los datos ingresados!",
          icon: "warning",
          text: warnText,
          iconHtml: `<i class="fa fa-exclamation-circle" aria-hidden="true"></i>`,
          confirmButtonColor: `#6bd098`,
          confirmButtonText: `entendido`,
          showConfirmButton: true,
        });
      } else {
        // console.log("sssss");
        // console.log(errFields.length);
        try {
          response = await this.$MasterControlAPP.post(
            "",
            {
              Parameters: { id: id },
              Body: updatedShift,
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                operation: "/v1/update/shift",
                // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q")).MembershipsStatistics,
              },
            }
          );
          // console.log("response");
          // console.log(response);
        } catch (error) {
          console.error(error.message);
          console.error(error);
          this.$swal.fire({
            title: "Error!",
            icon: "error",
            text:
              error.message ||
              "Ha ocurrido un error inesperado, por favor intentalo mas tarde o ponte en contacto con soporte",
          });
        }
        this.$swal.close();
        if (response.data.result) {
          this.$refs.shiftDetailCard.editSuccess();
          await this.$swal
            .fire({
              title: "Exito!",
              text: "El turno ha sido actualizado! (:",
              icon: "success",
              confirmButtonColor: `#6bd098`,
            })
            .then(async (res) => {
              const tableCurrentPage = this.$refs.shiftsTable.getCurrentPage();
              const shifts = this.shifts;
              this.shifts = shifts.map((shift) => {
                if (shift.id === id) {
                  return {
                    id: id,
                    ...updatedShift,
                  };
                } else {
                  return shift;
                }
              });
              // await this.getShiftResum(tableCurrentPage);
              this.$swal.fire({
                text: `Quieres aplicar esta actualización a los planes en venta que utilizan el turno [${updatedShift.descripcionTurno}]?`,
                icon: "question",
                iconHtml: `<i class="fa fa-question" aria-hidden="true"></i>`,
                confirmButtonColor: `#6bd098`,
                cancelButtonColor: "#ef8157",
                showCancelButton: true,
                confirmButtonText: "Actualizar",
                cancelButtonText: `cancelar`,
                preConfirm: async () => {
                  this.$swal.fire({
                    title: "Actualizando...",
                    text: "Un segundo....",
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    didOpen: () => {
                      this.$swal.showLoading();
                    },
                  });
                  await this.$MasterControlAPP
                    .post(
                      "",
                      {
                        Parameters: { id: id },
                        Body: updatedShift,
                      },
                      {
                        headers: {
                          "Content-Type": "application/json",
                          token: sessionStorage.getItem("jCxbraoQeD"),
                          operation: "/v1/update/shift/in/plans",
                          // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q")).MembershipsStatistics,
                        },
                      }
                    )
                    .then((res) => {
                      if (res.data.error) {
                        this.$swal.fire({
                          title: "Error",
                          text:
                            res.data.error ||
                            "Ha ocurrido un error inesperado, por favor vuelve a intentarlo mas tarde o ponte en contacto con soporte",
                          icon: "error",
                        });
                      } else {
                        const successText = res.data.result
                          ? `Se han actualizado ${res.data.result} planes de forma exitosa`
                          : `La operación se ejcutó correctamente pero al parecer no hubo coincidencias`;
                        this.$swal.fire({
                          title: "Exito!",
                          text: successText,
                          icon: "success",
                          confirmButtonColor: `#6bd098`,
                        });
                      }
                    });
                },
              });
            });
        } else if (response.data.error) {
          this.$swal.fire({
            title: "Error!",
            text:
              response.data.error ||
              "Ha ocurrido un error inesperado, vuelve a intentarlo mas tarde o ponte contacto con soporte",
            icon: "error",
          });
        } else {
          this.$swal.fire({
            title: "Ups!",
            text: "Al parecer el turno que buscas ya no existe, por favor refresca la venta y vuelve a intentar",
            icon: "warning",
            iconHtml: `<i class="fa fa-exclamation-circle" aria-hidden="true"></i>`,
            confirmButtonColor: `#6bd098`,
          });
        }
      }
    },
    async handleDisablingEditing(shiftOG) {
      this.shiftDetails = _.cloneDeep(shiftOG);
    },
    async handleShiftDetailClose() {
      // console.log("Exc - handleShiftDetailClose");
      this.shiftDetails = {};
      this.enableShiftEdit = null;
      this.showShiftDetails = false;
      this.shrinkShiftsTable = false;
    },
    async getShift(id) {
      let response;
      // console.log("iniciando GetShift: ", id);
      this.enableShiftEdit = false;
      try {
        response = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: { shift: id },
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              operation: "/v1/get/shift",
              // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q")).MembershipsStatistics,
            },
          }
        );

        // console.log(response.data.result);
      } catch (error) {
        console.error("Error");
        console.error(error);
        this.$swal.fire({
          title: "Error!",
          text:
            error.message ||
            "Error desconcido, vuelve a intentarlo mas tarde o ponte en contacto con soporte",
          icon: "error",
        });
        return null;
      }
      if (response.data.error) {
        this.$swal.fire({
          title: "Error!",
          text: response.data.error,
          icon: "error",
        });
        return null;
      }
      // console.log(response.data);
      return response.data.result;
    },
    async deleteFamily(id) {
      const familyId = id;
      // console.log("familyId: " + familyId);
      var isConfirmed;
      await this.$swal
        .fire({
          title: "Estas seguro?",
          text: "Tambien eliminaras todas las subfamilias!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Si, eliminalo!",
          cancelButtonText: "Cancelar",
        })
        .then((res) => {
          // console.log(res);
          isConfirmed = res.isConfirmed;
        });

      if (isConfirmed) {
        // console.log("Eliminando familia...");
        this.$swal.fire({
          title: "Cargando",
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: () => {
            this.$swal.showLoading();
          },
        });
        try {
          await this.$MasterControlAPP
            .post(
              "",
              {
                Parameters: {
                  id: familyId,
                },
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  token: sessionStorage.getItem("jCxbraoQeD"),
                  operation: "/v1/delete/family",
                  // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                  //   .AccessStatistics,
                },
              }
            )
            .then((resp) => {
              // console.log("resp++++++++++++++++++++");
              // console.log(resp);
              this.$swal.close();
              if (resp.data.error) {
                this.$swal.fire({
                  title: "Ha ocurrido un error :(!",
                  icon: "error",
                  text: resp.data.error,
                  showConfirmButton: true,
                });
              } else {
                // console.log(resp);
                const familys = this.familys;
                this.familys = [];
                this.familys = familys.filter((fam) => fam._id !== familyId);
                this.$swal.fire({
                  title: "Exito",
                  icon: "success",
                });
                // this.$router.push("#");
                // this.getFamilys();
              }
            });
        } catch (ex) {
        } finally {
          this.filters.update = true;
          return;
        }
      } else {
        console.warn("Eliminacion canselada por usuario");
      }
    },
    async deleteSubFamily(id) {
      const subSamilyId = id;
      // console.log("familyId: " + familyId);
      var isConfirmed;
      await this.$swal
        .fire({
          title: "Estas seguro?",
          text: "Esto no puede revertirse",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Si, eliminalo!",
          cancelButtonText: "Cancelar",
        })
        .then((res) => {
          // console.log(res);
          isConfirmed = res.isConfirmed;
        });

      if (isConfirmed) {
        // console.log("Eliminando familia...");
        this.$swal.fire({
          title: "Cargando",
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: () => {
            this.$swal.showLoading();
          },
        });
        try {
          await this.$MasterControlAPP
            .post(
              "",
              {
                Parameters: {
                  id: subSamilyId,
                },
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  token: sessionStorage.getItem("jCxbraoQeD"),
                  operation: "/v1/delete/subfamily",
                  // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                  //   .AccessStatistics,
                },
              }
            )
            .then((resp) => {
              // console.log("resp++++++++++++++++++++");
              // console.log(resp);
              this.$swal.close();
              if (resp.data.error) {
                this.$swal.fire({
                  title: "Ha ocurrido un error :(!",
                  icon: "error",
                  text: resp.data.error,
                  showConfirmButton: true,
                });
              } else {
                // console.log(resp);
                this.$swal.fire({
                  title: "Exito",
                  icon: "success",
                });
                // this.$router.push("#");
                this.getSubFamilys();
              }
            });

          const subFamilys = this.subFamilys;
          this.subFamilys = [];
          this.subFamilys = subFamilys.filter(
            (subFam) => subFam.id !== subSamilyId
          );
        } catch (ex) {
        } finally {
          this.filters.update = true;
          return;
        }
      } else {
        console.warn("Eliminacion cancelada por usuario");
      }
    },
    async deleteShift(id) {
      const shiftId = id;
      // console.log("familyId: " + familyId);

      // console.log("Eliminando turno...");
      this.$swal.fire({
        title: "Cargando",
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          this.$swal.showLoading();
        },
      });
      try {
        // console.log(`Eliminando turno n°${shiftId}`);
        // console.log(`Iniciando llamada a "/v1/delete/shift"`);
        await this.$MasterControlAPP
          .post(
            "",
            {
              Parameters: {
                id: shiftId,
              },
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                operation: "/v1/delete/shift",
                // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                //   .AccessStatistics,
              },
            }
          )
          .then((resp) => {
            // console.log("resp++++++++++++++++++++");
            // console.log(resp);
            this.$swal.close();
            if (resp.data.error) {
              this.$swal.fire({
                title: "Ha ocurrido un error :(!",
                icon: "error",
                text: resp.data.error,
                showConfirmButton: true,
              });
              return;
            } else {
              // console.log(resp);
              this.$swal
                .fire({
                  title: "Exito",
                  icon: "success",
                })
                .then((res) => {
                  this.$refs.shiftDetailCard.close();
                  this.showShiftDetails = false;
                  this.shiftsCount = this.shiftsCount - 1;
                  this.shrinkShiftsTable = false;
                });
            }
          });
        const shifts = this.shifts;
        this.shifts = [];

        this.shifts = shifts.filter((shift) => shift.id !== shiftId);
      } catch (ex) {
        console.error("Error");
        console.error(ex);
        this.$swal.fire({
          title: "Error!",
          text:
            ex.message ||
            "Error desconcido, vuelve a intentarlo mas tarde o ponte en contacto con soporte",
          icon: "error",
        });
      }
    },
    async handleDeleteShift(id) {
      // console.log(id);
      this.$swal.fire({
        title: `Esta acción no se puede revertir!`,
        text: `Eliminaras el turno: ${this.shiftDetails.descripcionTurno}`,
        icon: "warning",
        confirmButtonText: `ELIMINAR`,
        showCancelButton: true,
        confirmButtonColor: "#6bd098",
        cancelButtonColor: "#ef8157",
        iconHtml: '<i class="fa fa-exclamation" aria-hidden="true"></i>',
        preConfirm: async (res) => {
          // console.log(res);
          await this.deleteShift(id);
        },
      });
    },
    async handlePageChange(page) {
      await this.getShiftResum(page);
    },
    async handleShowShift(id) {
      this.$swal.fire({
        title: "Cargando...",
        text: "Un momento por favor",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      // console.log(id);
      let shiftData;
      try {
        shiftData = await this.getShift(id);
        // // console.log("respuesta en handler");
        // console.log(shiftData);
      } catch (error) {
        console.error("Error");
        console.error(error);
        this.$swal.fire({
          title: "Error!",
          text:
            error.message ||
            "Error desconcido, vuelve a intentarlo mas tarde o ponte en contacto con soporte",
          icon: "error",
        });
      }
      if (shiftData) {
        this.$swal.close();
        this.shrinkShiftsTable = true;
        this.showShiftDetails = true;
      } else {
        // console.log(shiftData);
        this.$swal.fire({
          title: "Ups!",
          text: "Al parecer este turno ya no se encuentra disponible, refresca la pagina",
          icon: "warning",
        });
        this.shiftDetails = {};
        this.shrinkShiftsTable = false;
        this.showShiftDetails = false;
      }
      this.$nextTick(() => {
        // console.log("next ticking");
        this.$refs.shiftDetailCard.disableEdit();
        if (shiftData) {
          this.shiftDetails = _.cloneDeep(shiftData);
        }
      });
    },
    async getShiftResum(page) {
      this.$swal.fire({
        title: "cargando...",
        text: "Un segundo por favor",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      this.shifts = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
      let response;
      try {
        response = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: {
              page: isNaN(page) || !page ? 0 : page - 1,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              operation: "/v1/get/shifts/resum/pag",
              // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q")).MembershipsStatistics,
            },
          }
        );
      } catch (ex) {
        this.$swal.fire({
          title: "Error!",
          text:
            ex.message ||
            "Ha ocurrio un error inesperado al consultar los turnos, vuelve a intentarlo mas tarde o ponte en contacto con soporte",
        });
      }
      if (response.data.result && response.data.result.docs.length > 0) {
        // console.log(response.data.result);
        const documents = response.data.result.docs;
        const total = response.data.result.total;
        this.shifts = [...documents];
        if (this.shiftsCount != total) {
          this.shiftsCount = total;
        }
        this.$swal.close();
      } else {
        this.$swal
          .fire({
            title: "Aún no has creado turnos para tu GYM",
            text: "¿Quieres comenzar ahora?",
            icon: "info",
            showConfirmButton: true,
            showCancelButton: true,
            cancelButtonText: "NO",
            confirmButtonText: "CREAR",
            confirmButtonColor: "#6bd098",
            cancelButtonColor: "#ef8157",
            iconHtml: '<i class="fa fa-exclamation" aria-hidden="true"></i>',
          })
          .then((res) => {
            if (res.isConfirmed) {
              this.$swal.fire({
                title: "cargando...",
                text: "Un segundo por favor",
                showConfirmButton: false,
                allowOutsideClick: false,
                didOpen: () => {
                  this.$swal.showLoading();
                },
              });
              this.$router.push("/plans/create");
            }
          });
      }
    },
  },
  async mounted() {
    await this.getShiftResum(0);
  },
  beforeMount() {
    if (this.$sidebar.isMinimized) {
      this.$sidebar.toggleMinimize();
    }
    this.$swal.close();
  },
};
</script>

<style></style>
